import { IBRIDGE_COURSE_CONTENT, PROGRAMS_LOADING } from "../actions/types";

const initialState = {
  loading: false,
  ibridgeCourses: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case PROGRAMS_LOADING:
      return {
        ...state,
        loading: true,
      };
    case IBRIDGE_COURSE_CONTENT:
      return {
        ...state,
        ibridgeCourses: action.payload,
        loading: false,
      };
    default:
      return state;
  }
}
